<template>
  <div>
    <list row-key="id" ref="list" unit="快递模板" :page="page" :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus">新建快递模板</el-button>
      </template>
      <template slot="table">
        <el-table-column prop="快递LOGO" label="快递" min-width="100px">
          <div slot-scope="{row}" class="logo">
            <el-image style="width: 60px;height: 60px;" :src="row.快递LOGO"></el-image>
          </div>
        </el-table-column>
        <el-table-column prop="所属店铺" label="所属店铺" min-width="200px" />
        <el-table-column prop="网点发货地址文本" label="网点发货地址" min-width="400px">
          <template slot-scope="{row}">
            <div>
              <span>地址：</span>
              <span>{{ row.网点发货地址文本 }}</span>
              <el-button style="margin-left: 15px;padding: 3px 10px;" type="primary"
                @click="editDot(row)">编辑</el-button>
            </div>
            <div v-if="!row.isChange">
              <template>
                <span>余额：</span>
                <span style="color: #02A7F0;">{{ row.余额 }}</span>
              </template>
              <template v-if="row.已用">
                <span style="margin-left: 15px;">已用：</span>
                <span style="color: #D9001B;">{{ row.已用 }}</span>
              </template>
              <template v-if="row.取消">
                <span style="margin-left: 15px;">取消：</span>
                <span style="color: #7F7F7F;">{{ row.取消 }}</span>
              </template>
            </div>
            <div v-else style="color: #D9001B;">网点地址发生变更，请修改</div>
          </template>
        </el-table-column>
        <el-table-column prop="是否启用" label="是否启用" align="center" min-width="80px">
          <template slot-scope="{row}">
            <el-switch v-model="row.是否启用" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="模板名称" label="模板名称" min-width="180px" />
        <el-table-column prop="模板样式" label="模板样式" min-width="180px" />
        <el-table-column prop="默认发货地址" label="默认发货地址" min-width="400px" />
        <el-table-column label="操作" width="150px" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="primary" @click="edit(row)">编辑</el-button>
            <el-button type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <create-dialog ref="createDialog" @close-saved="reload" />
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <dot-dialog ref="dotDialog" @close-saved="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import createDialog from "./createDialog"
import editDialog from "./editDialog"
import dotDialog from "./dotDialog"

export default {
  mixins: [listMixin],
  components: { list, createDialog, editDialog, dotDialog },
  data() {
    return {
      pddApi: {
        logistics: require('@/api/pdd/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
    };
  },
  created() {
    this.sysType = localStorage.getItem("sys_type");
    this.mallToken = localStorage.getItem("token");
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.getCustomtemplates().then(res => {
          console.log("getDataFunc", res)
          resolve(res)
        }).catch(error => {
          resolve({ Code: 1, data: [] })
        });
      })
    },
    create() {
      if (this.$refs.list.loading) {
        this.$message.warning("列表加载中，请稍候");
        return;
      }
      this.$refs.createDialog.openCreate()
    },
    //编辑快递网点
    editDot(data) {
      this.$refs.dotDialog.openEdit(data)
    },
    edit(data) {
      this.$refs.editDialog.openEdit(data)
    },
    setDefault(data) {
      console.log("setDefault", data)
    },
    onDelete(data) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        console.log("删除", data)
      }).catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
}
</style>